module.exports = __webpack_public_path__ + "static/img/xwk_tittle1.6ca24bad.png";